module.exports = __webpack_public_path__ + "cssPostit.svg?eb26586779228132eddea8e1c0a55f24";